module.exports = __webpack_public_path__ + "static/img/logo@2x.1368651.png";